export default "__VITE_ASSET__DYWNJW16__"